import e from "../../../@babel/runtime/helpers/esm/typeof.mjs";
import o from "../_lib/requiredArgs/index.mjs";
function n(t) {
  return o(1, arguments), t instanceof Date || e(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
export {
  n as default
};
